if (!customElements.get('mobile-sticky-atc')) {
  customElements.define('mobile-sticky-atc', class extends HTMLElement {
    connectedCallback() {
      this.productForm = document.getElementById(`ProductForm-${this.dataset.sectionId}`);
      this.mainButton = this.productForm?.querySelector('[name="add"]');
      if (!this.mainButton) return;
      this.button = this.querySelector('[data-sticky-add]');
      this.defaultLabel = this.button.textContent;
      this.price = document.getElementById(`Product-Price-${this.dataset.sectionId}`);
      this.mobile = window.matchMedia('(max-width: 989px)');
      this.sync = this.update.bind(this);
      this.onClick = () => {
        if (this.productForm.dataset.available === 'false') {
          const restock = this.productForm.querySelector('[data-back-in-stock]');
          restock?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          const email = this.productForm.querySelector('#Globo-Back-In-Stock input[type="email"]');
          if (email) setTimeout(() => email.focus({ preventScroll: true }), 350);
          return;
        }
        if (this.button.disabled) return;
        this.mainButton.click();
      };
      this.button.addEventListener('click', this.onClick);
      this.mobile.addEventListener('change', this.sync);
      document.addEventListener('fm:size-unit-change', this.sync);
      this.onScroll = () => {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;
          this.update();
        });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.intersection = new IntersectionObserver(entries => {
        this.pastForm = entries[0].boundingClientRect.bottom < 0;
        this.update();
      });
      this.intersection.observe(this.productForm);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.productForm, { attributes: true, subtree: true, childList: true, characterData: true });
      if (this.price) this.observer.observe(this.price, { subtree: true, childList: true, characterData: true });
      this.sizeButton = this.querySelector('[data-change-size]');
      this.onSizeChange = () => {
        const selector = document.querySelector(`product-selector[data-section-id="${this.dataset.sectionId}"]`);
        const variant = selector?.variants.find(item => String(item.id) === this.sizeButton.value);
        if (!variant) return;
        let changedInput;
        selector.querySelectorAll('[data-input-wrapper]').forEach((wrapper, index) => {
          const select = wrapper.querySelector('select');
          if (select) { select.value = variant.options[index]; changedInput = select; }
          else {
            const radio = Array.from(wrapper.querySelectorAll('input[type="radio"]')).find(input => input.value === variant.options[index]);
            if (radio) { radio.checked = true; changedInput = radio; }
          }
        });
        changedInput?.dispatchEvent(new Event('change', { bubbles: true }));
      };
      this.sizeButton?.addEventListener('change', this.onSizeChange);
      this.update();
    }
    update() {
      this.pastForm = this.productForm.getBoundingClientRect().bottom < 0;
      const available = this.productForm.dataset.available === 'true';
      const selector = document.querySelector(`product-selector[data-section-id="${this.dataset.sectionId}"]`);
      this.hidden = !(this.mobile.matches && this.pastForm && selector?.currentVariant);
      this.button.disabled = available && (this.mainButton.disabled || this.mainButton.classList.contains('disabled'));
      this.button.textContent = available
        ? (this.productForm.form.querySelector('[name="properties[pre-order]"]') ? this.mainButton.textContent : this.defaultLabel)
        : this.button.dataset.stickyNotify;
      if (this.price) this.querySelector('.mobile-sticky-atc__price').innerHTML = this.price.innerHTML;
      const unit = window.fmSizeUnit || 'EU';
      const unitLabel = this.querySelector('[data-sticky-size-unit]');
      if (unitLabel) unitLabel.textContent = unit === 'USA' ? 'US' : unit;
      if (this.sizeButton) Array.from(this.sizeButton.options).forEach(option => {
        const variant = selector?.variants.find(item => String(item.id) === option.value);
        if (!variant) return;
        const euSize = variant.option1;
        const converted = window.fmSizeMappings?.[euSize]?.[unit];
        const base = converted || variant.title;
        option.textContent = `${base}${variant.available ? '' : ` — ${this.sizeButton.dataset.soldOut || 'Sold out'}`}`;
      });
      if (this.sizeButton && selector?.currentVariant) {
        this.sizeButton.value = String(selector.currentVariant.id);
        this.sizeButton.hidden = selector.currentVariant.title === 'Default Title';
      }
      const source = selector?.currentVariant?.featured_image?.src;
      const image = this.querySelector('img');
      if (source && image) { image.removeAttribute('srcset'); image.src = source; }
    }
    disconnectedCallback() {
      this.intersection?.disconnect();
      window.removeEventListener('scroll', this.onScroll);
      cancelAnimationFrame(this.scrollFrame);
      this.observer?.disconnect();
      this.mobile?.removeEventListener('change', this.sync);
      document.removeEventListener('fm:size-unit-change', this.sync);
      this.button?.removeEventListener('click', this.onClick);
      this.sizeButton?.removeEventListener('change', this.onSizeChange);
    }
  });
}
